export enum MedicineEvent {
  Created = 0,
  Add = 1,
  Use = 2,
  Adjust = 3,
  Edit = 4,
}
